/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabaseClient';

const FEATURES = [
  { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" strokeWidth="1.8"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>, title: 'Dashboard multi-biens', desc: 'Tous vos logements, revenus agrégés et calendriers groupés en un seul endroit.' },
  { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" strokeWidth="1.8"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>, title: 'Emma IA par bien', desc: "Répond automatiquement aux voyageurs 24h/24, dans leur langue." },
  { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>, title: 'Calendrier groupé', desc: 'Disponibilités de tous vos biens sur un seul calendrier, par couleur.' },
  { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" strokeWidth="1.8"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>, title: 'Revenus par bien', desc: 'Performance individuelle, part du total, historique complet.' },
  { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" strokeWidth="1.8"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>, title: 'Messages centralisés', desc: 'Toutes les conversations de tous vos biens dans une boîte unique.' },
  { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" strokeWidth="1.8"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>, title: 'Gestion des tâches', desc: 'Assignez ménages et interventions à vos prestataires par email.' },
];

const COMPARATIF = [
  { label: 'Commission plateforme', havenly: '8% → 12%', guesty: '+15% Airbnb', airbnb: '15,5%' },
  { label: 'Abonnement mensuel', havenly: '0 EUR', guesty: '150-500 EUR', airbnb: '0 EUR' },
  { label: 'Emma IA incluse', havenly: true, guesty: false, airbnb: false },
  { label: 'Dashboard multi-biens', havenly: true, guesty: true, airbnb: false },
  { label: 'Messages centralisés', havenly: true, guesty: true, airbnb: false },
  { label: 'Frais voyageur', havenly: '0 EUR', guesty: '0 EUR', airbnb: '14%' },
];

const CHAT_SEQUENCE = [
  { from: 'emma', text: "Bonjour ! Je suis Emma, votre assistante IA. Je gère vos biens 24h/24 — réponses voyageurs, calendriers, tâches ménage. Comment puis-je vous aider ?", delay: 600 },
  { from: 'user', text: "Quels revenus j'ai générés pour l'appartement situé à Nice ce mois-ci ?", delay: 2200 },
  { from: 'typing', delay: 3400 },
  { from: 'emma', text: "Ce mois-ci, l'Appartement Nice centre a généré 2 840 EUR nets — 18 nuits réservées sur 30, taux d'occupation 60%. Votre meilleure performance depuis 3 mois !", delay: 4800 },
  { from: 'user', text: "Super ! Et bloque du 3 au 7 mai sur la villa bord de mer.", delay: 6600 },
  { from: 'typing', delay: 7800 },
  { from: 'emma', text: "Fait ! 5 jours bloqués sur la Villa bord de mer — du 3 au 7 mai. Calendrier mis à jour.", delay: 9000 },
];

function EmmaChatHero() {
  const [messages, setMessages] = useState([]);
  const [showTyping, setShowTyping] = useState(false);
  const [inputVal, setInputVal] = useState('');
  const [seqDone, setSeqDone] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    let timers = [];
    CHAT_SEQUENCE.forEach((msg, i) => {
      if (msg.from === 'typing') {
        const t = setTimeout(() => setShowTyping(true), msg.delay);
        timers.push(t);
      } else {
        const t = setTimeout(() => {
          setShowTyping(false);
          setMessages(prev => [...prev, msg]);
          if (i === CHAT_SEQUENCE.length - 1) setSeqDone(true);
        }, msg.delay);
        timers.push(t);
      }
    });
    return () => timers.forEach(clearTimeout);
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, showTyping]);

  const sendMsg = () => {
    if (!inputVal.trim()) return;
    setMessages(prev => [...prev, { from: 'user', text: inputVal }]);
    setInputVal('');
    setShowTyping(true);
    setTimeout(() => {
      setShowTyping(false);
      setMessages(prev => [...prev, { from: 'emma', text: "Compris ! Je m'en occupe immédiatement." }]);
    }, 1500);
  };

  return (
    <div style={{ background: '#0A1612', padding: '4rem 2rem', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 70% 0%, rgba(29,158,117,0.1) 0%, transparent 55%)', pointerEvents: 'none' }} />
      <div style={{ maxWidth: 960, margin: '0 auto', display: 'grid', gridTemplateColumns: window.innerWidth < 700 ? '1fr' : '1fr 1fr', gap: 52, alignItems: 'center', position: 'relative', zIndex: 1 }}>

        {/* Gauche — texte */}
        <div>
          <div style={{ display: 'inline-block', background: 'rgba(29,158,117,0.15)', border: '1px solid rgba(29,158,117,0.3)', color: '#1D9E75', fontSize: 11, fontWeight: 500, padding: '4px 12px', borderRadius: 20, marginBottom: 18, letterSpacing: '0.4px' }}>
            Pour les professionnels
          </div>
          <h1 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(28px, 4vw, 42px)', color: '#fff', letterSpacing: '-1px', lineHeight: 1.1, marginBottom: 14 }}>
            La plateforme pensée<br/>
            <em style={{ color: '#1D9E75', fontStyle: 'italic' }}>pour les conciergeries</em>
          </h1>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)', lineHeight: 1.85, marginBottom: 28 }}>
            Gérez tous vos biens depuis une interface unique. Commission réduite, Emma IA incluse, sans abonnement mensuel.
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <a href="#formulaire" style={{ padding: '12px 24px', background: '#1D9E75', color: '#fff', borderRadius: 24, fontSize: 13, fontWeight: 500, textDecoration: 'none', display: 'inline-block' }}>
              Demander un accès →
            </a>
            <a href="#comparatif" style={{ padding: '12px 24px', background: 'transparent', color: 'rgba(255,255,255,0.45)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 24, fontSize: 13, textDecoration: 'none', display: 'inline-block' }}>
              Voir le comparatif
            </a>
          </div>
        </div>

        {/* Droite — chat Emma */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
            <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#1D9E75', animation: 'pulse 2s infinite' }} />
            <span style={{ fontSize: 12, color: '#1D9E75', fontWeight: 500 }}>Emma</span>
            <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', letterSpacing: '0.3px' }}>· assistante IA · en ligne</span>
          </div>

          <div style={{ maxHeight: 320, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 10, paddingRight: 4 }}>
            {messages.map((msg, i) => (
              <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: msg.from === 'user' ? 'flex-end' : 'flex-start' }}>
                <div style={{ fontSize: 10, color: msg.from === 'emma' ? '#1D9E75' : 'rgba(255,255,255,0.25)', marginBottom: 4 }}>
                  {msg.from === 'emma' ? 'Emma' : 'Vous'}
                </div>
                <div style={{
                  maxWidth: '88%', padding: '10px 14px', fontSize: 13, lineHeight: 1.65,
                  borderRadius: msg.from === 'emma' ? '0 14px 14px 14px' : '14px 0 14px 14px',
                  background: msg.from === 'emma' ? 'rgba(29,158,117,0.1)' : 'rgba(255,255,255,0.06)',
                  border: msg.from === 'emma' ? '1px solid rgba(29,158,117,0.2)' : '1px solid rgba(255,255,255,0.1)',
                  color: msg.from === 'emma' ? 'rgba(255,255,255,0.85)' : 'rgba(255,255,255,0.65)',
                }}>
                  {msg.text}
                </div>
              </div>
            ))}
            {showTyping && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div style={{ fontSize: 10, color: '#1D9E75', marginBottom: 4 }}>Emma</div>
                <div style={{ padding: '10px 14px', background: 'rgba(29,158,117,0.08)', border: '1px solid rgba(29,158,117,0.15)', borderRadius: '0 14px 14px 14px', display: 'flex', gap: 4 }}>
                  {[0,1,2].map(j => (
                    <div key={j} style={{ width: 5, height: 5, borderRadius: '50%', background: '#1D9E75', opacity: 0.5, animation: `dot 1.4s ${j*0.2}s infinite` }} />
                  ))}
                </div>
              </div>
            )}
            <div ref={bottomRef} />
          </div>

          {/* Input */}
          <div style={{ marginTop: 14, display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 24, padding: '6px 6px 6px 16px' }}>
            <input value={inputVal} onChange={e => setInputVal(e.target.value)} onKeyDown={e => e.key === 'Enter' && sendMsg()}
              placeholder="Posez une question à Emma..." style={{ flex: 1, background: 'none', border: 'none', outline: 'none', fontSize: 13, color: 'rgba(255,255,255,0.55)', fontFamily: 'var(--sans)' }} />
            <button onClick={sendMsg} style={{ width: 30, height: 30, borderRadius: '50%', background: '#1D9E75', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
            </button>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.3} }
        @keyframes dot { 0%,80%,100%{opacity:0.4;transform:scale(1)} 40%{opacity:1;transform:scale(1.3)} }
      `}</style>
    </div>
  );
}

export default function ConciergeriePage({ onNavigate }) {
  const [form, setForm] = useState({ name: '', company: '', email: '', phone: '', nbBiens: '', siret: '', message: '' });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const isMobile = window.innerWidth < 640;

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.phone || !form.nbBiens || !form.company) return;
    setSending(true);
    try {
      await supabase.from('concierge_requests').upsert({
        email: form.email.toLowerCase().trim(),
        name: form.name,
        company_name: form.company,
        phone: form.phone,
        nb_biens: form.nbBiens,
        siret: form.siret || null,
        message: form.message || null,
        status: 'pending',
      }, { onConflict: 'email' });

      await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'concierge_request',
          to: 'contact@havenly.fr',
          data: {
            name: form.name, company: form.company, email: form.email,
            phone: form.phone, nbBiens: form.nbBiens,
            siret: form.siret || 'non renseigné',
            message: form.message || '',
            date: new Date().toLocaleString('fr-FR'),
          }
        })
      });
      setSent(true);
    } catch (e) { console.error(e); }
    setSending(false);
  };

  return (
    <div style={{ background: 'var(--white)', minHeight: '100vh', paddingTop: 60 }}>

      <EmmaChatHero />

      {/* Stats bar */}
      <div style={{ background: '#0F1A16', borderTop: '1px solid rgba(255,255,255,0.06)', borderBottom: '1px solid rgba(255,255,255,0.06)', padding: '1.5rem 2rem' }}>
        <div style={{ maxWidth: 700, margin: '0 auto', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)', gap: 16 }}>
          {[
            { val: '8%', label: 'Commission à vie pour les 50 premiers', sub: 'Sinon 8% / 3 mois puis 12%' },
            { val: '0 EUR', label: 'Frais pour vos voyageurs', sub: 'vs 14% chez Airbnb' },
            { val: '24h', label: 'Versement après check-in', sub: 'directement sur votre compte' },
          ].map(s => (
            <div key={s.label} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 30, fontWeight: 500, color: '#1D9E75', fontFamily: 'var(--serif)' }}>{s.val}</div>
              <div style={{ fontSize: 12, color: '#fff', fontWeight: 500, marginTop: 4 }}>{s.label}</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', marginTop: 2 }}>{s.sub}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Features */}
      <section style={{ padding: '3rem 2rem', background: 'var(--surface)' }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <h2 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(22px, 3vw, 36px)', letterSpacing: '-0.5px', marginBottom: 6 }}>Tout ce dont vous avez besoin</h2>
          <p style={{ fontSize: 13, color: 'var(--ink-3)', marginBottom: 24 }}>Sans abonnement Guesty à 300 EUR/mois</p>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12 }}>
            {FEATURES.map(f => (
              <div key={f.title} style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 14, padding: 20, borderTop: '2px solid #1D9E75' }}>
                <div style={{ width: 38, height: 38, background: '#E8F5F0', borderRadius: 9, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>{f.icon}</div>
                <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 5 }}>{f.title}</div>
                <div style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.65 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Comparatif */}
      <section id="comparatif" style={{ padding: '3rem 2rem', background: 'var(--white)' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <h2 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(22px, 3vw, 36px)', letterSpacing: '-0.5px', marginBottom: 6 }}>Havenly vs les alternatives</h2>
          <p style={{ fontSize: 13, color: 'var(--ink-3)', marginBottom: 24 }}>Ce que vous payez vraiment</p>
          <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 14, overflow: 'hidden' }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#0F1A16' }}>
                    <th style={{ padding: '12px 16px', textAlign: 'left', color: 'rgba(255,255,255,0.35)', fontWeight: 400, fontSize: 11 }}>Critère</th>
                    <th style={{ padding: '12px 16px', textAlign: 'center' }}><span style={{ background: 'rgba(29,158,117,0.2)', border: '1px solid rgba(29,158,117,0.3)', color: '#1D9E75', fontSize: 12, fontWeight: 500, padding: '4px 12px', borderRadius: 20, display: 'inline-block' }}>Havenly</span></th>
                    <th style={{ padding: '12px 16px', textAlign: 'center', color: 'rgba(255,255,255,0.35)', fontSize: 12, fontWeight: 400 }}>Guesty / Hostaway</th>
                    <th style={{ padding: '12px 16px', textAlign: 'center', color: 'rgba(255,255,255,0.35)', fontSize: 12, fontWeight: 400 }}>Airbnb seul</th>
                  </tr>
                </thead>
                <tbody>
                  {COMPARATIF.map((row, i) => (
                    <tr key={row.label} style={{ borderTop: '1px solid var(--border)', background: i % 2 === 0 ? 'var(--white)' : 'var(--surface)' }}>
                      <td style={{ padding: '12px 16px', fontWeight: 500 }}>{row.label}</td>
                      {[row.havenly, row.guesty, row.airbnb].map((val, j) => (
                        <td key={j} style={{ padding: '12px 16px', textAlign: 'center' }}>
                          {typeof val === 'boolean'
                            ? <span style={{ color: val ? '#1D9E75' : 'var(--ink-4)', fontSize: 15 }}>{val ? '✓' : '—'}</span>
                            : <span style={{ color: j === 0 ? '#1D9E75' : 'var(--ink-3)', fontWeight: j === 0 ? 500 : 400 }}>{val}</span>
                          }
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Formulaire */}
      <section id="formulaire" style={{ padding: '3rem 2rem', background: 'var(--surface)' }}>
        <div style={{ maxWidth: 580, margin: '0 auto' }}>
          {sent ? (
            <div style={{ background: 'var(--white)', border: '2px solid #1D9E75', borderRadius: 20, padding: '3rem', textAlign: 'center' }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#E8F5F0', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1D9E75" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
              <h2 style={{ fontFamily: 'var(--serif)', fontSize: 22, marginBottom: 10 }}>Demande envoyée !</h2>
              <p style={{ fontSize: 14, color: 'var(--ink-3)', lineHeight: 1.7, marginBottom: 20 }}>Matthieu vous contactera personnellement sous 24h pour configurer votre espace gestionnaire.</p>
              <button onClick={() => onNavigate('home')} style={{ padding: '11px 24px', background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 24, fontSize: 14, fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)' }}>Retour à l'accueil</button>
            </div>
          ) : (
            <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 20, padding: isMobile ? '1.5rem' : '2.5rem' }}>
              <h2 style={{ fontFamily: 'var(--serif)', fontSize: 26, letterSpacing: '-0.5px', marginBottom: 6 }}>Demander un accès</h2>
              <p style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.7, marginBottom: 24 }}>Notre équipe configure votre espace gestionnaire sous 24h et vous accompagne dans la prise en main.</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 6 }}>Prénom et nom *</label>
                    <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="Marie Dupont"
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', boxSizing: 'border-box' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 6 }}>Nom de la conciergerie *</label>
                    <input value={form.company} onChange={e => setForm(p => ({ ...p, company: e.target.value }))} placeholder="Conciergerie Dupont"
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', boxSizing: 'border-box' }} />
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 6 }}>Email *</label>
                    <input type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} placeholder="marie@conciergerie.fr"
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', boxSizing: 'border-box' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 6 }}>Téléphone *</label>
                    <input value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} placeholder="06 12 34 56 78"
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', boxSizing: 'border-box' }} />
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 6 }}>Nombre de biens gérés *</label>
                    <select value={form.nbBiens} onChange={e => setForm(p => ({ ...p, nbBiens: e.target.value }))}
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', background: 'var(--white)', boxSizing: 'border-box' }}>
                      <option value="">— Choisir —</option>
                      <option value="1-5">1 à 5 biens</option>
                      <option value="5-15">5 à 15 biens</option>
                      <option value="15-30">15 à 30 biens</option>
                      <option value="30+">Plus de 30 biens</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 6 }}>SIRET <span style={{ fontWeight: 400 }}>(optionnel)</span></label>
                    <input value={form.siret} onChange={e => setForm(p => ({ ...p, siret: e.target.value }))} placeholder="123 456 789 00012"
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', boxSizing: 'border-box' }} />
                  </div>
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 6 }}>Message <span style={{ fontWeight: 400 }}>(optionnel)</span></label>
                  <textarea value={form.message} onChange={e => setForm(p => ({ ...p, message: e.target.value }))} placeholder="Décrivez votre activité, les plateformes que vous utilisez actuellement..."
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', resize: 'vertical', minHeight: 80, boxSizing: 'border-box' }} />
                </div>
                <button onClick={handleSubmit} disabled={sending || !form.name || !form.email || !form.phone || !form.nbBiens || !form.company}
                  style={{ width: '100%', padding: '13px', background: form.name && form.email && form.phone && form.nbBiens && form.company ? '#1D9E75' : 'var(--border)', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 500, cursor: form.name && form.email && form.phone && form.nbBiens && form.company ? 'pointer' : 'default', fontFamily: 'var(--sans)' }}>
                  {sending ? 'Envoi...' : 'Envoyer ma demande →'}
                </button>
                <p style={{ fontSize: 12, color: 'var(--ink-4)', textAlign: 'center', margin: 0 }}>Matthieu vous répond personnellement sous 24h</p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* CTA final */}
      <section style={{ padding: '3rem 2rem', background: '#0A1612', textAlign: 'center' }}>
        <h2 style={{ fontFamily: 'var(--serif)', fontSize: 26, color: '#fff', letterSpacing: '-0.5px', marginBottom: 8 }}>Une question ?</h2>
        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.35)', marginBottom: 20 }}>Contactez-nous directement par email.</p>
        <a href="mailto:contact@havenly.fr" style={{ display: 'inline-block', padding: '11px 24px', background: 'transparent', color: '#1D9E75', border: '1px solid #1D9E75', borderRadius: 24, fontSize: 14, fontWeight: 500, textDecoration: 'none' }}>
          contact@havenly.fr
        </a>
      </section>
    </div>
  );
}
